export default __webpack_public_path__ + "static/media/Ellipse 111 (6).13d3f512.png";